










import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { AdminDepositBankAccountRoute } from '@/modules/deposit-bank-account/routes/admin-deposit-bank-account.route'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    ActionShowButton
  }
})
export default class AdminDepositBankAccountIndexPageTableActions extends Vue {
  constructor(
    private readonly routes: AdminDepositBankAccountRoute
  ) {
    super()
  }

  @Prop({ required: true }) accountId: number

  private get depositBankAccountShowPageLink() {
    return this.routes.show(this.accountId)
  }
}
